import React from "react";
import ReportsSection from "../../components/Investor/Reports.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const Report = () => {
  return (
    <div>
      <MetaComponent
        title="Financial Reports, Quarterly Results, Annual Statements & Investor Documents | Aptech Limited"
        desc="View Aptech Limited’s official financial reports, quarterly results, annual statements, and other key investor documents in one convenient location."
        keywords="Quarterly and annual reports of Aptech, Aptech Investor relations, Financial statements of Aptech."
      />
      <ReportsSection />
    </div>
  );
};

export default Report;
